import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMainPageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.23223 1.56622C3.70107 1.09738 4.33696 0.833984 5 0.833984H11.6667C11.8877 0.833984 12.0996 0.921782 12.2559 1.07806L17.2559 6.07806C17.4122 6.23434 17.5 6.4463 17.5 6.66732V16.6673C17.5 17.3304 17.2366 17.9662 16.7678 18.4351C16.2989 18.9039 15.663 19.1673 15 19.1673H5C4.33696 19.1673 3.70107 18.9039 3.23223 18.4351C2.76339 17.9662 2.5 17.3304 2.5 16.6673V3.33398C2.5 2.67094 2.76339 2.03506 3.23223 1.56622ZM5 2.50065C4.77899 2.50065 4.56702 2.58845 4.41074 2.74473C4.25446 2.90101 4.16667 3.11297 4.16667 3.33398V16.6673C4.16667 16.8883 4.25446 17.1003 4.41074 17.2566C4.56702 17.4129 4.77899 17.5006 5 17.5006H15C15.221 17.5006 15.433 17.4129 15.5893 17.2566C15.7455 17.1003 15.8333 16.8883 15.8333 16.6673V7.01249L11.3215 2.50065H5Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.6667 0.833984C12.1269 0.833984 12.5 1.20708 12.5 1.66732V5.83398H16.6667C17.1269 5.83398 17.5 6.20708 17.5 6.66732C17.5 7.12755 17.1269 7.50065 16.6667 7.50065H11.6667C11.2064 7.50065 10.8333 7.12755 10.8333 6.66732V1.66732C10.8333 1.20708 11.2064 0.833984 11.6667 0.833984Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83334 10.8333C5.83334 10.3731 6.20643 10 6.66667 10H13.3333C13.7936 10 14.1667 10.3731 14.1667 10.8333C14.1667 11.2936 13.7936 11.6667 13.3333 11.6667H6.66667C6.20643 11.6667 5.83334 11.2936 5.83334 10.8333Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83334 14.1673C5.83334 13.7071 6.20643 13.334 6.66667 13.334H13.3333C13.7936 13.334 14.1667 13.7071 14.1667 14.1673C14.1667 14.6276 13.7936 15.0007 13.3333 15.0007H6.66667C6.20643 15.0007 5.83334 14.6276 5.83334 14.1673Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83334 7.49935C5.83334 7.03911 6.20643 6.66602 6.66667 6.66602H8.33334C8.79357 6.66602 9.16667 7.03911 9.16667 7.49935C9.16667 7.95959 8.79357 8.33268 8.33334 8.33268H6.66667C6.20643 8.33268 5.83334 7.95959 5.83334 7.49935Z",
			fill: "#FEFEFF"
		})
	]
});
export default SvgMainPageIcon;
